/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { ADD_BOX_NOTE } from "../graphql/addBoxNote.mutation";

const log: any = LoggerModule?.getInstance();

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IAddBoxNoteMethods extends IPluginMethodMap {
  addBoxNote(args: any): Promise<any>;
}

export class AddBoxNoteService implements IAgentPlugin {
  readonly methods: IAddBoxNoteMethods;

  constructor() {
    this.methods = {
      addBoxNote: this.addBoxNote.bind(this),
    };
  }

  async addBoxNote(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: ADD_BOX_NOTE,
          variables: {
            filter: {
              _id: args?.boxId,
            },
            update: {
              note: args?.note !== "delete" ? args?.note : "",
            },
          },
          fetchPolicy: "no-cache",
        });

        if (res?.data?.addBoxNote) {
          return {
            ...res?.data?.addBoxNote,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
